var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import id from "@irati/utils/id";
import { getProfileImage } from "@irati/utils/images/getImageSize/getImageSize";
import DefaultProfilePicture from "./DefaultProfilePicture";
import { Img } from "./styled";
var ProfilePicture = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    var user = props.user, deactivated = props.deactivated, border = props.border, defaultImageOverride = props.defaultImageOverride, marginRight = props.marginRight;
    var idNamespace = id("profile-picture", props);
    var profileImg = user.profileImageUrl || user.profile_img;
    var firstName = user.firstName || user.firstname;
    var lastName = user.lastName || user.lastname;
    var getPictureSize = function () {
        var small = props.small, regular = props.regular, large = props.large;
        if (small)
            return 30;
        else if (regular)
            return 50;
        else if (large)
            return 100;
        return undefined;
    };
    return profileImg ? (React.createElement(Img, { id: id("img", idNamespace), size: getPictureSize() || size, deactivated: deactivated, border: border, src: getProfileImage(profileImg, null, defaultImageOverride), alt: "profile_img", marginRight: marginRight })) : (React.createElement(DefaultProfilePicture, { id: idNamespace, deactivated: deactivated, firstname: firstName, lastname: lastName, size: getPictureSize() || size, border: border, marginRight: marginRight }));
};
export default ProfilePicture;
